import {
  mapApiToPriceItemType,
  type RawPriceItemType,
} from 'core/accounting/infra/PriceItemTypeMapper'

import { type Accessorial, type AccessorialRate } from '../domain/Accessorial'

export type RawAccessorial = {
  alice_id: number
  id: number
  label: string
  name: string
  shipper_notes?: string
}

export type RawPriceItemTypeWithNotes = RawPriceItemType & {
  shipper_notes?: string
}

export type RawAccessorialRate = {
  id: number
  notes: string
  rate: string
  type?: number
  last_rate?: string
  price_item_type: RawPriceItemType | null
}

export function mapApiToAccessorial(rawAccessorial: RawAccessorial): Accessorial {
  return {
    type: rawAccessorial.id,
    label: rawAccessorial.label,
    name: rawAccessorial.name,
    shipperNotes: rawAccessorial.shipper_notes || '',
  }
}

export function mapApiToAccessorialRate(rawRate: RawAccessorialRate): AccessorialRate {
  return {
    id: rawRate.id,
    notes: rawRate.notes || '',
    rate: rawRate.rate || '',
    type: rawRate.type,
    lastRate: rawRate.last_rate || '',
    priceItemType: rawRate.price_item_type
      ? mapApiToPriceItemType(rawRate.price_item_type)
      : undefined,
  }
}

export function mapApiToAccessorialRateList(
  rawRateList: Array<RawAccessorialRate>
): Array<AccessorialRate> {
  return rawRateList.map(rawRate => mapApiToAccessorialRate(rawRate))
}

export function mapAccessorialRateToApi(accessorialRate: AccessorialRate): Omit<
  RawAccessorialRate,
  'id' | 'price_item_type'
> & {
  id?: number
  price_item_type?: string
} {
  return {
    id: accessorialRate.id ?? undefined,
    notes: accessorialRate.notes,
    rate: accessorialRate.rate,
    type: accessorialRate.type,
    price_item_type: accessorialRate.priceItemType ? accessorialRate.priceItemType.uuid : undefined,
  }
}
